export enum PaymentCompany {
    None = 0,
    CargoWise = 1,
    NexGen = 2
}



// WEBPACK FOOTER //
// ./app/objects/payment/paymentCompany.ts